import { t } from 'i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import useMembers from '@/hooks/useMembers';

export const ColumnAvatar = ({ createdById }: { createdById: string }) => {
  const { getMember } = useMembers();
  const member = getMember(createdById);
  const fallback = member?.name ? member.name.charAt(0) : 's';

  return (
    <InfoTooltip content={member?.name || t('common.system')} delayDuration={300}>
      <Avatar size="xs">
        <AvatarImage src={member?.avatar || ''} alt={`${member?.name}'s avatar`} />
        {fallback ? <AvatarFallback>{fallback}</AvatarFallback> : t('common.system')}
      </Avatar>
    </InfoTooltip>
  );
};
